export const CATEGORY_LIST = 'category_list';
